<template>
  <transition name="modal">
    <div v-if="isVisible" class="modal-mask" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-content">
          <!-- 第一行：图片上传 -->
          <div class="modal-row">
            <label>相册图片</label>
            <el-upload
              class="avatar-uploader"
              action="#"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :http-request="handleAvatarUpload"
            >
              <img v-if="localMuseumDetailInfo.imageUrl" :src="localMuseumDetailInfo.imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          
          <!-- 第二行：城市名称（两列布局） -->
          <div class="modal-row two-columns">
            <div class="column">
              <label>相片介绍</label>
            </div>
            <div class="column">
              <el-input 
                v-model="localMuseumDetailInfo.name" 
                placeholder="请输入相册名称"
              ></el-input>
            </div>
          </div>
          
          <!-- 第三行：描述 -->
          <div class="modal-row two-columns">
            <div class="column">
              <label>归属相册</label>
            </div>
            <div class="column" style="z-index: 1001 !important">
              <el-select style="z-index: 1001 !important"
                v-model="localMuseumDetailInfo.typeId" 
                placeholder="请选择相册类别"
                class="category-select"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.typeId"
                  :label="item.typeName"
                  :value="item.typeId"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="modal-row two-columns">
            <div class="column">
              <label>位置信息</label>
            </div>
            <div class="column">
              <el-input 
                v-model="localMuseumDetailInfo.position" 
                placeholder="请输入位置信息"
              ></el-input>
            </div>
          </div>
          <div class="modal-row two-columns">
            <div class="column">
              <label>描述信息</label>
            </div>
            <div class="column">
              <el-input 
                v-model="localMuseumDetailInfo.content" 
                placeholder="请输入描述信息"
              ></el-input>
            </div>
          </div>
          <div class="modal-row two-columns">
            <div class="column">
              <label>是否精选</label>
            </div>
            <div class="column">
              <select v-model="localMuseumDetailInfo.curated" class="status-select">
                <option value="0">否</option>
                <option value="1">是</option>
              </select>
            </div>
          </div>

          <div class="modal-row two-columns">
            <div class="column">
              <label>状态管理</label>
            </div>
            <div class="column">
              <select v-model="localMuseumDetailInfo.status" class="status-select">
                <option value="0">正常</option>
                <option value="1">禁用</option>
              </select>
            </div>
          </div>
          
          <!-- 第四行：操作按钮 -->
          <div class="modal-row button-row">
            <el-button @click="closeModal">关闭窗口</el-button>
            <el-button @click="clearForm">清空数据</el-button>
            <el-button type="primary" @click="submitForm">提交数据</el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Message } from 'element-ui';

import { getAlbumTypeList, saveMuseumDetail } from '@/api/album';

export default {
  name: 'CreateMuseumDetail',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    MuseumDetailInfo: {
      type: Object,
      default: () => ({
        id: null,
        typeId: '',
        type: '',
        position: '',
        curated: '',
        content: '',
        status: '',
        desc: '',
        imageUrl: '',
        imageFile: null
      })
    },
  },
  data() {
    return {
      localMuseumDetailInfo: {
        ...this.MuseumDetailInfo,
        imageUrl: '', // 确保有初始化
        imageFile: null
      },
      categoryOptions: []
    }
  },
  mounted(){
    this.queryMuseumTypeList();
  },
  methods: {
    async queryMuseumTypeList(){
        const params = {status: 0};
        try{
            const resp = await getAlbumTypeList(params);
            if (resp.code === 200 && resp.success && resp.data != []) {
                this.categoryOptions = resp.data.map(item => ({
                  typeId: item.id,
                  typeName: item.name
                }));
            } else {
              Message.error(resp.msg || '获取相册类别类别数据失败！');
            }
      } catch (error) {
        Message.error('请求失败: ' + error.msg);
      }
    },
    clearForm() {
      this.localMuseumDetailInfo = {
        id: null,
        typeId: '',
        type: '',
        position: '',
        curated: '0',
        content: '',
        status: '',
        desc: '',
        imageUrl: '',
        imageFile: null
      }
    },
    closeModal() {
      this.clearForm();
      this.isVisible = !this.isVisible;
      this.$emit('update:visible', false);
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.includes('image/');
      const isLt2M = file.size / 1024 / 1024 < 20;

      if (!isImage) {
        Message.error('只能上传图片文件!');
      }
      if (!isLt2M) {
        Message.error('图片大小不能超过20MB!');
      }

      return isImage && isLt2M;
    },
    handleAvatarUpload({ file }) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.localMuseumDetailInfo.imageUrl = e.target.result;
        this.localMuseumDetailInfo.imageFile = file;
      };
      reader.readAsDataURL(file);
    },
    async submitForm() {
      if (!this.localMuseumDetailInfo.name) {
        Message.error('照片描述必填哦！');
        return;
      }
      if (!this.localMuseumDetailInfo.typeId) {
        Message.error('归属相册必选哦！');
        return;
      }
      if (!this.localMuseumDetailInfo.status) {
        Message.error('状态必选哦！');
        return;
      }

      const formData = new FormData();
      // 2. 添加 cityInfo 对象（转换为JSON字符串）
      const museumDetail = {
        id: this.localMuseumDetailInfo.id,
        typeId: this.localMuseumDetailInfo.typeId,
        name: this.localMuseumDetailInfo.name,
        content: this.localMuseumDetailInfo.content,
        curated: this.localMuseumDetailInfo.curated,
        position: this.localMuseumDetailInfo.position,
        status: this.localMuseumDetailInfo.status
      }
      formData.append('museumDetail', JSON.stringify(museumDetail))
      
      // 3. 添加文件
      if (this.localMuseumDetailInfo.imageFile) {
        formData.append('file', this.localMuseumDetailInfo.imageFile);
      }
      const configParams = {headers: {
        'Content-Type': 'multipart/form-data'
      }}

      try {
        const resp = await saveMuseumDetail(formData, configParams);
        if (resp.code === 200 && resp.success) {
          Message.success('操作成功！');
          this.$emit('saved', resp.data);
          this.closeModal();
        } else {
          Message.error(resp.msg || '操作失败');
        }
      } catch (error) {
        Message.error('请求失败: ' + error.msg);
      }
    }
  }
}
</script>

<style scoped>

@media(max-width: 768px){
.modal-container {
  width: 90% !important;
  padding: 6px !important;
}
}
.modal-mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;
}

.modal-container {
  width: 50%;
  min-height: 60%;
    /* iOS风格毛玻璃效果 */
  background-color: rgba(255, 255, 255, 0.6);
  /* 提高透明度 */
  backdrop-filter: blur(16px) saturate(180%);
  /* 增加模糊和饱和度 */
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.modal-row {
  margin-bottom: 20px;
}

.two-columns {
  display: flex;
  align-items: center;
}

.column {
  flex: 1;
}

.status-select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.column:first-child {
  margin-right: 15px;
  min-width: 100px;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.button-row button {
  margin-left: 10px;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/* 过渡动画 */
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  transform: scale(0.9);
}
</style>